/**
 * Identify internal CMS sources whose content is rendered on a public main page.
 * CommonJS keeps this rule shared by the web app and the untranspiled sitemap server.
 *
 * @param {string} pageId - Console page ID.
 * @returns {boolean} Whether the page should be excluded from search indexes.
 */
const shouldNoIndexCmsPage = pageId =>
  typeof pageId === 'string' && (pageId.startsWith('curated-') || /--rt-part-\d{3}$/.test(pageId));

module.exports = { shouldNoIndexCmsPage };
